module.exports = __webpack_public_path__ + "static/media/medium-set.8faf68fd.png";